export default __webpack_public_path__ + "static/media/kayak_light.f267e708.png";